export default __webpack_public_path__ + "static/Swiss721BT-Bold-8e7df6390f98ee351f198f4e9ddbe783.eot";